/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";

import { StyledLabel, StyledRequired } from "../superAdmin/catalog/lib/styles";
import { theme } from "../theme/theme";

type Option = {
  id: string;
  label: string;
};

type AutocompleteInputFieldPropTypes = {
  disabled?: boolean;
  handleChange: (event, newValue) => void;
  id: string;
  isRequired?: boolean;
  label?: string;
  options: Option[];
  selectedOptions: Option[];
};

const StyledAutocomplete = withStyles({
  root: {
    "& .MuiAutocomplete-popupIndicator": {
      "& .MuiSvgIcon-root": {
        color: `${theme.color.black}`,
        fontSize: `${theme.fontSize.xxl}`,
      },
    },
    "& .MuiAutocomplete-clearIndicator": {
      "& .MuiSvgIcon-root": {
        color: `${theme.color.black}`,
        fontSize: `${theme.fontSize.l}`,
      },
    },
    "& .MuiAutocomplete-endAdornment": {
      top: "calc(50% - 12px)",
    },
  },
  paper: {
    color: `${theme.color.gray800}`,
    fontSize: `${theme.fontSize.m}`,
    fontFamily: `${theme.fontFamily}`,
  },
  tag: {
    backgroundColor: `${theme.color.gray200}`,
    height: 24,
    position: "relative",
    zIndex: 0,
    "& .MuiChip-label": {
      color: `${theme.color.gray800}`,
      fontSize: `${theme.fontSize.m}`,
      fontFamily: `${theme.fontFamily}`,
      overflow: "visible",
    },
    "& .MuiChip-deleteIcon": {
      color: `${theme.color.gray200}`,
    },
    "&:after": {
      content: '""',
      right: 10,
      top: 6,
      height: 12,
      width: 12,
      position: "absolute",
      backgroundColor: `${theme.color.gray500}`,
      zIndex: -1,
    },
  },
  input: {
    border: "none!important",
    color: `${theme.color.gray800}`,
    fontSize: `${theme.fontSize.m}`,
    fontFamily: `${theme.fontFamily}`,
  },
})(Autocomplete);

const StyledTextField = withStyles({
  root: {
    fontSize: `${theme.fontSize.m}`,
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: `${theme.color.gray800}`,
        borderWidth: "1px",
      },
    },
  },
})(TextField);

const AutocompleteInputField = ({
  disabled,
  handleChange,
  id,
  isRequired,
  label,
  options,
  selectedOptions,
}: AutocompleteInputFieldPropTypes): React.ReactElement => {
  return (
    <>
      {label && (
        <StyledLabel htmlFor={id}>
          {label}
          {isRequired && <StyledRequired>*</StyledRequired>}
        </StyledLabel>
      )}
      <StyledAutocomplete
        data-testid={id}
        disabled={disabled}
        id={id}
        filterSelectedOptions
        getOptionLabel={(option: Option): string => {
          return option.label;
        }}
        getOptionSelected={(option: Option, value: Option): boolean => {
          return option.id === value.id;
        }}
        multiple
        onChange={handleChange}
        options={options}
        renderInput={(params): React.ReactChild => {
          return <StyledTextField {...params} variant="outlined" />;
        }}
        value={selectedOptions}
      />
    </>
  );
};

AutocompleteInputField.defaultProps = {
  label: "",
  isRequired: false,
};

export default AutocompleteInputField;
